import { createFileRoute } from '@tanstack/react-router';
import { LeaveWorkflow } from '@/features/leave/LeaveWorkflow';

export const Route = createFileRoute('/_app/leave')({ component: LeaveWorkflow });
